import React, { useState, useEffect } from 'react';
import { useEscapeClose } from '../../../utils/SamuiUtils';
import { getRowStyle } from '../../../utils/ModalKeyboardNavigation';

const SoModal = ({ showSoModal, handleSoClose, dlLineList, onRowSelectDL }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredDlLineList, setFilteredDlLineList] = useState([]);
    const [selectedRowIndex, setSelectedRowIndex] = useState(0);

    useEscapeClose(showSoModal, handleSoClose);

    useEffect(() => {
        setFilteredDlLineList(
            dlLineList.filter(dl =>
                dl.DL_LineName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                dl.DL_Remark.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, dlLineList]);

    useEffect(() => {
        if (showSoModal) {
            setSearchTerm('');
            setSelectedRowIndex(0);
        }
    }, [showSoModal]);

    return (
        <>
            <div className={`modal ${showSoModal ? 'show' : ''}`} style={{ display: showSoModal ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">รายชื่อสายส่ง</h5>
                            <button type="button" className="close" onClick={handleSoClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <span className="fw-bold">ค้นหาเอกสาร</span>
                                        <input
                                            style={{ width: '100%' }}
                                            type="text"
                                            className="form-control"
                                            value={searchTerm || ''}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th className="text-center" style={{ width: '10%' }}>ลำดับ</th>
                                            <th className="text-center" style={{ width: '20%' }}>ชื่อสายส่ง</th>
                                            <th className="text-center" style={{ width: '70%' }}>รายละเอียดสายส่ง</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            filteredDlLineList.map((dl, index) => (
                                                <tr
                                                    key={dl.DL_Id || index + 1}

                                                    style={getRowStyle(index, selectedRowIndex)} onClick={() => {
                                                        setSelectedRowIndex(index);
                                                        onRowSelectDL(dl);
                                                    }}>

                                                    <td className="text-center">{index + 1}</td>
                                                    <td className="text-left">{dl.DL_LineName}</td>
                                                    <td className="text-left">{dl.DL_Remark}</td>
                                                </tr>
                                            ))

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={handleSoClose}>ปิด</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SoModal;
